module.exports = __webpack_public_path__ + "static/media/ReloadIcon_Light.920e79c8.svg";